import React, { useEffect } from "react";
import { useLocalStore, useStoreState } from "easy-peasy";
import { Typography, Box } from "@mui/material";
import { OutlinedBtn } from "components/admin_v2/ui/Buttons";
import BreadCrumbs from "components/admin_v2/common/BreadCrumbs";
import Spinner from "components/admin_v2/ui/Spinner";
import TopPageLayout from "components/admin_v2/nav/TopPageLayout";
import SchoolConfigTabs from "components/admin_v2/settings_config/SettingsConfigTabs";
import UserForm from "components/admin_v2/settings_config/users/UserForm";
import I18n from "utils/i18n.js";
import { usersStore } from "components/admin_v2/common/stores/usersStore";
import { pageRoutes } from "services/api";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";

const UserEdit = (props) => {
  const { user: currentUser, isRestrictedAdmin } = useStoreState((s) => s.app);
  const cls = useCommonPageStyles();
  const [state, actions] = useLocalStore(() => usersStore({ role: "admin" }));
  const user = state.user;
  const id = props.match.params.id;

  useEffect(() => {
    if (!id) return;

    actions.fetchUser(id);

    return () => {
      actions.setUser(null);
    };
  }, [id]);

  if (isRestrictedAdmin && currentUser?.id != id) {
    return null;
  }

  return (
    <React.Fragment>
      <TopPageLayout title={I18n.t("settings_config.title")} />
      <SchoolConfigTabs />
      <BreadCrumbs path={pageRoutes.users()} label={I18n.t("settings_config.users.breadcrumb")} />
      {user && (
        <Box className={cls.titleWithBtn}>
          <Typography variant="h1" gutterBottom>
            {user.name}
          </Typography>
          <Box className={cls.btnsWrapper}>
            <OutlinedBtn className={cls.actionBtn} onClick={() => actions.resetPassword(id)}>
              {I18n.t("ui.btn.reset_password")}
            </OutlinedBtn>
            <OutlinedBtn className={`${cls.actionBtn} active`} disabled>
              {I18n.t("settings_config.edit_user.btn")}
            </OutlinedBtn>
            {!isRestrictedAdmin && (
              <OutlinedBtn className={cls.actionBtn} onClick={() => actions.toggleArchive(id)}>
                {user.discarded ? I18n.t("ui.btn.unarchive") : I18n.t("ui.btn.archive")}
              </OutlinedBtn>
            )}
          </Box>
        </Box>
      )}
      {state.loading ? <Spinner /> : <UserForm role={state.role} user={user} />}
    </React.Fragment>
  );
};

export default UserEdit;
